import styled, { css } from 'styled-components';
import theme from '../../constants/theme';

export type TChatBubbleSC = {
  isMe?: boolean;
  isSequence?: boolean;
  styleType?: string;
};

export const ChatBubbleSC = styled.div<TChatBubbleSC>`
  display: flex;
  margin-bottom: 4px;
  line-height: 1;
  margin-top: ${({ isSequence }) => (isSequence ? 0 : '16px')};

  a {
    text-decoration: underline;
  }

  ${({ isMe }) => {
    if (isMe) {
      return css`
        flex-direction: row-reverse;
        padding-left: 40px;
        a {
          color: #fff;
        }
        .cb-message {
          margin-right: 10px;
        }
        .cb-message:before {
          right: -4px;
          transform: rotate(180deg);
        }
      `;
    }
    return css`
      padding-right: 40px;
      .cb-message {
        margin-left: 10px;
      }
      .cb-message:before {
        left: -4px;
      }
    `;
  }};

  .cb-time {
    display: block;
    text-align: right;
    margin-top: 2px;
    font-size: 10px;
    color: ${({ isMe, styleType }) => {
      if (isMe) {
        return '#fff;';
      }
      if (styleType === 'WARNING') {
        return `${theme.colors.error};`;
      }
      return 'rgba(51,61,108,0.6);';
    }};
  }

  .cb-avatar {
    min-width: 32px;
  }

  .cb-title {
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    color: ${({ styleType }) => (styleType === 'WARNING' ? theme.colors.error : '#9ea3b8')};
    margin-bottom: 0;
  }

  .cb-message {
    position: relative;
    white-space: pre-line;
    border-radius: 16px;
    padding: 10px 22px 16px;
    background: ${({ isMe, styleType }) => {
      if (isMe) {
        return 'linear-gradient(90deg, #5967A6 0%, #505D95 13.15%, #333D6C 85.16%, #293157 100%);';
      }
      if (styleType === 'WARNING') {
        return '#ffeaee;';
      }
      return 'rgba(234, 235, 240, 0.5);';
    }};

    &:before {
      position: absolute;
      display: ${({ isSequence }) => (isSequence ? 'none' : 'inline-block')};
      top: 10px;
      content: '';
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 5px 5px 5px 0;
      border-color: transparent
        ${({ isMe, styleType }) => {
          if (isMe) {
            return '#293157';
          }
          if (styleType === 'WARNING') {
            return '#ffeaee';
          }
          return 'rgba(234, 235, 240, 0.5)';
        }}
        transparent transparent;
    }

    p {
      margin-bottom: 0;
      line-height: 1.4;
      color: ${({ isMe, styleType }) => {
        if (isMe) {
          return '#fff;';
        }
        if (styleType === 'WARNING') {
          return `${theme.colors.error};`;
        }
        return `${theme.colors.font};`;
      }};
    }
  }

  .cb-attachment {
    width: 150px;
    border-radius: 5px;
    margin: 5px 0;
    cursor: pointer;
  }
`;
